/**
 * @file
 * Example of a custom script file.
 */

(($, Drupal) => {
  Drupal.behaviors.GDSSubthemeGlobal = {
    attach: (context, settings) => {
      var host = window.location.host;
      var isExternal = function (hostname) {
        return (hostname !== host);
      };
      //AA for links without data-it-asset
        $("a").each(function () {
          let dis = $(this);
          if (!$(this).hasClass("use-ajax") && (dis[0].hostname && isExternal(dis[0].hostname) == false)) {
            if (!$(this).attr("data-it-asset")) {
              var title_val = $(this).attr("title");
              if (typeof title_val === "undefined") {
                var text = $(this)
                  .html()
                  .replace(/(<([^>]+)>)/gi, "")
                  .replace(/&nbsp;/gi, " ")
                  .trim();
                text = text.replace(/\s\s+/g, " ");
                $(this).attr("title", text);
                $(this).attr("data-it-button", text);
              } else {
                $(this).attr("data-it-button", title_val);
              }
            }
          }
          if ($(this).attr("target") == "_blank") {
            $(this).attr("rel", "noopener");
          }

  //AA for buttons without data-it-asset
        $(".gds-btn").each(function () {
          if (!$(this).hasClass("use-ajax") && (dis[0].hostname && isExternal(dis[0].hostname) == false)) {
            if (!$(this).attr("data-it-asset")) {
              var title_val = $(this).attr("title");
              $(this).attr("data-it-button", title_val);
            }
          }
        });
      // target self and blank noopener for SEO
      $('a[target="_self"], button[target="_self"]').attr("rel", "noopener");
      $('a[target="_blank"], button[target="_blank"]').attr("rel", "noopener");
      $("a.skip-disclaimer:not([href*='bipdf'])").attr("target", "_self").attr("rel", "noopener");
      $("a.use-ajax").attr("target", "_blank").attr("rel", "noopener");
        // AA for exit links
        $(".use-ajax").each(function () {
          var link = $(this).attr("href");
          var ext_path = link.split("?external=").pop();
          var ext_url = decodeURIComponent(ext_path);
          $(this).attr("data-it-exit-link", ext_url);
        });
        //breadcrumb data-it-button fix
        $("li.gds-breadcrumb__list-item").each(function (index) {
          var buttonText = $(this).find("span[itemprop='name']").text();
          $(this).find("a[itemprop='item']").attr("title", buttonText);
          $(this).find("a[itemprop='item']").attr("aria-label", buttonText);
          $(this).find("a[itemprop='item']").attr("data-it-button", buttonText);
        });
        $("a.skip-disclaimer").each(function () {
          var title = $(this).attr("title");
          if (
            title &&
            !$(this).attr("data-it-asset") &&
            !$(this).attr("data-it-exit-link")
          ) {
            $(this).attr("data-it-button", title.trim());
            $(this).attr("aria-label", title.trim());
          }
        });
      }, 800);
      // AA for logo.
      $("a.gds-logo").each(function () {
        var dis = $(this);
        var title = dis.attr("title");
        var sitename = $('meta[property="og:site_name"]').attr("content");
        if (!title) {
          dis.attr("title", Drupal.t("logo:"));
          dis.find("img").attr("alt", Drupal.t("logo: " + sitename));
        }
        dis.find("img").attr("alt", title);
        dis.find("img").attr("title", title);
        dis.attr("data-it-button", Drupal.t("logo: " + sitename));
      });
      // Video image seo.
      setTimeout(function () {
        $('video-js').each(function () {
          let name = $(this).attr('name') ? $(this).attr('name') : $('meta[property="og:site_name"]').attr("content");
          $(this).find('img').attr('title', name);
          $(this).find('img').attr('alt', name);
        });
      }, 1000);
      // AA for Tabs
      $(".gds-tabs button").each(function () {
        let attrTitle = $(this).attr('title');
        $(this).attr('data-it-button', attrTitle);
      });

    },
  };
  window.addEventListener('scroll', function () {
    const header = document.getElementById('block-hackathon-header');
    const stickyPoint = header.offsetTop;
    window.pageYOffset > stickyPoint ?  header.classList.add('sticky') : header.classList.remove('sticky');
  });
})(jQuery, Drupal);